/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Response } from '@app/models';
import { AdminPayrollService } from './payroll.service';

@Injectable()
export class AdminPayrollBatchResolverService implements Resolve<Response> {
  constructor(private assPayrollService: AdminPayrollService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    if (route.params.year && route.params.month) {
      return this.assPayrollService.getBatch(route.params.year, route.params.month).pipe(
        take(1),
        map(res => {
          if (res.error === false) return res['data'];
          else return false;
        })
      );
    } else {
      return false;
    }
  }
  
}
